export const columns = function () {
    return [
        {
            prop: 'orgName',
            label: '机构名称',
            minWidth: 150
        },
		{
		    prop: 'realname',
		    label: '业务员',
		    minWidth: 100
		},
		{
		    prop: 'offerNum',
		    label: '报价个数',
			sortable: true,
		    minWidth: 100
		},
		{
		    prop: 'offerMoney',
		    label: '报价应交（元）',
			sortable: true,
		    minWidth: 150
		},
        {
            prop: 'billNum',
            label: '出单个数',
            sortable: true,
            minWidth: 100
        },
        {
            prop: 'billMoney',
            label: '出单应交（元）',
            sortable: true,
            minWidth: 150
        },
		{
		    prop: 'payMoney',
		    label: '出单实收（元）	',
		    sortable: true,
		    minWidth: 150
		},
		{
		    prop: 'billNetFee',
		    label: '出单净费（元）	',
		    sortable: true,
		    minWidth: 150
		},
		{
		    prop: 'returnNum',
		    label: '退单个数',
			sortable: true,
		    minWidth: 100
		},
		{
		    prop: 'returnMoney',
		    label: '退单金额（元）',
			sortable: true,
		    minWidth: 150
		},
		{
		    prop: 'correctNum',
		    label: '批单个数',
			sortable: true,
		    minWidth: 100
		},
		{
		    prop: 'correctMoney',
		    label: '批单金额（元）',
			sortable: true,
		    minWidth: 150
		},
		{
		    prop: 'correctFee',
		    label: '批单净费（元）	',
		    sortable: true,
		    minWidth: 150
		},
    ]
}

export default {}